import { useFormikContext } from 'formik'
import { DialogActions } from '@mui/material'

import PropTypes from 'prop-types'
import { Button } from '@collaborate-health/uikit'

const DialogActionsWithFormik = ({ onClose }) => {
  const { isSubmitting, dirty, isValid, submitForm, resetForm } = useFormikContext()

  const handleClose = () => {
    onClose()
    resetForm()
  }

  return (
    <DialogActions>
      {onClose && (
        <Button onClick={handleClose} variant='text'>
          Cancel
        </Button>
      )}
      <Button variant='contained' color='primary' onClick={submitForm} disabled={!dirty || isSubmitting || !isValid}>
        Save
      </Button>
    </DialogActions>
  )
}

DialogActionsWithFormik.propTypes = {
  onClose: PropTypes.func,
}

export default DialogActionsWithFormik
